<template>
  <div class="side-menu-area-container">
    <div class="side-menu-area">
      <SideMenuHeader :title="title" />
      <SideMenu />
      <SideMenuBreadcrumb class="side-menu-breadcrumb" />
      <Copyright class="copyright" />
      <img
        src="../assets/images/udmark-light.png"
        class="ud-mark-img"
        alt=" "
      />
      <h1 class="ud-mark-text">&nbsp;</h1>
    </div>
  </div>
</template>

<script>
import SideMenuHeader from "@/components/SideMenuHeader.vue";
import SideMenu from "@/components/SideMenu.vue";
import SideMenuBreadcrumb from "@/components/SideMenuBreadcrumb.vue";
import Copyright from "@/components/common/Copyright.vue";
import { onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "SideMenuArea",
  components: {
    SideMenuHeader,
    SideMenu,
    SideMenuBreadcrumb,
    Copyright,
  },
  props: {
    title: String,
  },
  setup() {
    const store = useStore();
    const bgClass = document.getElementsByClassName("ud-mark-text");
    const imgClass = document.getElementsByClassName("ud-mark-img");
    let lightImg = require("../assets/images/udmark-light.png")
    let darkImg = require("../assets/images/udmark-dark.png")

    onMounted(() => {
      changeImg();
      changeColor();
    });

    store.subscribe((mutation) => {
      if (mutation.type === 'toggleDarkMode') {
        //ダークモード切り替わり検知、表示切替
        changeImg();
        changeColor();
      }
    })

    //ダークモード画像切り替え
    const changeImg = () => {
      if (store.state.isDarkMode == true) {
        //ダークモードオフ
        for (let i = 0; i < imgClass.length; i++) {
          imgClass[0].setAttribute('src', darkImg);
        }
      } else if (store.state.isDarkMode == false) {
        //ダークモードオン
        for (let i = 0; i < imgClass.length; i++) {
          imgClass[0].setAttribute('src', lightImg);
        }
      }
    }
    //ダークモードStyle切り替え
    const changeColor = () =>{
      for (let i = 0; i < bgClass.length; i++) {
        if (store.state.isDarkMode) {
          bgClass[0].className = "ud-mark-text dark-mode";
        } else {
          bgClass[0].className = "ud-mark-text";
        }
      }
    }
  }
};
</script>

<style scoped lang="stylus">
@import '../assets/styles/config.styl'
.side-menu-area-container
  direction rtl
.side-menu-area
  direction ltr
  min-height 100%
  padding 0 0 60px
  background-color var(--light-beige)
  transition all .5s ease-out;
.dark-mode
  .side-menu-area
    background-color var(--dark-black)
    transition all .5s ease-out;
.side-menu-breadcrumb
  padding 20px
.copyright
  padding 0 20px

.ud-mark-img
  width:110px
  margin-top:40px
  margin-bottom:5px
  padding 0 20px
  margin-left:2.5%
.ud-mark-text
  width:95%
  padding 0 20px
  margin-bottom:50px
  margin-left:2.5%
  color var(--light-black)
  font-size 12px
  transition: all 0.5s ease-out
  &.dark-mode
    color: var(--dark-white)
</style>
